import type { Technology } from 'domain/shared/career';
import type { PositionType } from 'domain/shared/employee';
import type { PositionProfileListItem, PositionProfileListRow } from '../types';
import { createPositionProfileLabelsResolver } from '../shared/utils/positionProfileLabels';

export const mapPositionProfileListRows = (
  profiles: PositionProfileListItem[],
  positions: PositionType[],
  technologies: Technology[],
): PositionProfileListRow[] => {
  const resolveLabels = createPositionProfileLabelsResolver(positions, technologies);

  return profiles.map(profile => ({
    ...profile,
    ...resolveLabels(profile),
  }));
};
